import { createFileRoute, Outlet } from '@tanstack/react-router'

/** One contract, its edit page and its paper copy (the edit and print pages sit under its crumb). */
export const Route = createFileRoute('/_app/service/contracts/$contractId')({
  staticData: { crumb: 'serviceContract' },
  component: Outlet,
})
